var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.btnFlag)?_c('img',{staticClass:"go-top",attrs:{"src":_vm.top},on:{"click":_vm.backTop}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }